// Styled Components
import styled from "styled-components";

const Footer = () => {
  return (
    <Wrapper>
      <div className="img-wrapper">
        <img
          src="https://cdn.discordapp.com/attachments/896285560094748713/896305035363901460/logo.png"
          alt=""
        />
        <p className="content">shoeuzi by j-ldn</p>
      </div>

      <div className="links">
        <p className="website-1">shoeuzi.com</p>
        <p className="website-2">shoeuzinft.com</p>
      </div>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  width: 100%;
  height: max-content;
  padding-top: 100px;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 50px;
  text-align: center;

  background-color: #000;

  .img-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    .content {
      font-weight: 700;
      font-size: 2rem;
    }
    img {
      width: 100px;
    }
  }
  .links {
    .website-1 {
      font-size: 1.75rem;
      font-weight: 100;
      font-family: sans-serif;
    }
    .website-2 {
      letter-spacing: 2px;
      font-size: 1.5rem;
      font-weight: 200;
      text-transform: uppercase;
      padding-top: 30px;
      text-align: center;
      font-size: 1.75rem;
      padding-bottom: 50px;
      font-family: "Pixeltype";
      font-weight: 200;

      font-size: 2rem;
      line-height: 48px;
    }
  }
`;
